import { GetListParams } from 'react-admin';
import { CustomDataProvider } from '../../../providers/CustomDataProvider';
import { baseUrl, httpClient } from '../../../providers/AppDataProvider';

export class ActivityTierBenefitsDataProvider implements CustomDataProvider {
  // eslint-disable-next-line class-methods-use-this
  async getList(resource: string, params: GetListParams): Promise<any> {
    if (resource !== 'activity-tier-benefit')
      return Promise.reject(new Error('Unsupported resource'));

    const { page = 1, perPage = 10 } = params.pagination || {};
    const { filter = {}, meta = {} } = params;
    const sort = JSON.stringify(params.sort);

    // 构建查询参数
    const searchParams = new URLSearchParams({
      sort,
      page: page.toString(),
      size: perPage.toString(),
      query: JSON.stringify(filter),
      ...meta,
    });

    // 构建请求 URL
    const url = `${baseUrl}/activity/adminGetAllTierBenefits?${searchParams.toString()}`;

    try {
      const { json } = await httpClient(url);

      // 根据您的数据结构处理数据
      // 这里假设您的 API 返回格式可能不同，需要特殊处理
      let rows: any[] = [];
      let total = 0;

      // 根据实际 API 响应结构调整
      if (json?.data) {
        rows = json.data;
      } else if (json?.tasks) {
        rows = json.tasks;
      } else if (Array.isArray(json)) {
        rows = json;
      } else {
        // 默认处理
        rows = json?.list ?? json?.items ?? json?.records ?? [];
      }
      total = rows.length;
      // 添加数据量检查，避免处理过多数据
      if (rows.length > 10000) {
        console.warn('Large dataset detected:', rows.length, 'items. Consider server-side pagination.');
      }

      //data 按照创建时间倒序
      rows.sort((a, b) => {
        const dateA = new Date(a.tierLevel || 0).getTime();
        const dateB = new Date(b.tierLevel || 0).getTime();
        return dateA - dateB;
      });

      // 确保每条记录都有 id，并限制处理的数据量
      const allData = rows.slice(0, 10000).map((r: any, i: number) => (r?.id != null ? r : { id: `${i}`, ...r }));

      // 前端分页处理
      const startIndex = (page - 1) * perPage;
      const endIndex = startIndex + perPage;
      const data = allData.slice(startIndex, endIndex);

      return { data, total: Math.min(total, 10000) };
    } catch (error) {
      console.error('ActivityTasksDataProvider getList error:', error);
      throw error;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async create(resource: string, params: any): Promise<any> {
    // 仅拦截 activity/tasks 列表对应的创建
    if (resource !== 'activity-tier-benefit')
      return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/createTierBenefit`;
    const payload = params?.data ?? {};

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async update(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-tier-benefit')
      return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/updateTierBenefit`;
    const payload = params?.data ?? {};
    // console.log('ActivityTasksDataProvider update payload:', params);

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json?.data ?? json };
  }

  // eslint-disable-next-line class-methods-use-this
  async delete(resource: string, params: any): Promise<any> {
    if (resource !== 'activity-tier-benefit')
      return Promise.reject(new Error('Unsupported resource'));

    const url = `${baseUrl}/activity/deleteTierBenefit`;
    const payload = { taskId: params?.id ?? params?.previousData?.id };

    const { json } = await httpClient(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });

    return { data: json ?? { id: payload.taskId } };
  }
}

// 创建实例并导出
export const activityTierBenefitsDataProvider = new ActivityTierBenefitsDataProvider();
